import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  transform<T extends object>(items: T[], searchText: string): T[] {
    if (!items) return [];
    if (!searchText) return items;

    const search = searchText.toLowerCase();

    return items.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(search)
      )
    );
  }
}